import React from 'react';

import ChatMessagePair from './chat-message';
import './index.css';

// props: { qaPairs: [], onChatSelected: function, selectedIndex}
const ChatList = (props) => {
	// MARK: - api calls
	return (
		<div className="chat-list-container">
			<div className="content-review-section-header">Conversation Record</div>
			<div className="chat-list-content">
				{props.qaPairs.map((chat, index) => (
					<ChatMessagePair
						key={index}
						chat={chat}
						onSelected={() => {
							props.onChatSelected(index);
						}}
						isSelected={props.selectedIndex === index}
					/>
				))}
			</div>
		</div>
	);
};

export default ChatList;
